"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSelectedL1CategoriesReducer = exports.defaultSelectedL1CategoriesState = void 0;
const actions = __importStar(require("./actions"));
const catalogs_1 = require("../../catalogs");
const updateSelectedL1Categories = (state, changes) => (Object.assign(Object.assign({}, state), changes));
exports.defaultSelectedL1CategoriesState = {
    extendedFilter: [],
};
const createSelectedL1CategoriesReducer = (entityPrefix, defaultState = exports.defaultSelectedL1CategoriesState) => (
// eslint-disable-next-line default-param-last
state = defaultState, action) => {
    var _a, _b;
    switch (action.type) {
        case `${catalogs_1.CATALOG_PREFIX}${entityPrefix}${actions.SET_TREE_NODE_FILTERING_STATE}`: {
            const { payload } = action;
            return updateSelectedL1Categories(state, payload.changes);
        }
        case `${catalogs_1.CATALOG_PREFIX}${entityPrefix}${actions.ADD_TO_EXCLUSIVE_FILTER}`: {
            const { payload } = action;
            const { nodeId } = payload !== null && payload !== void 0 ? payload : {};
            if (!nodeId)
                return state;
            const existing = (_a = state.exclusiveFilter) !== null && _a !== void 0 ? _a : [];
            const nodeExists = existing.some((category) => category.id === nodeId);
            if (nodeExists)
                return state;
            return updateSelectedL1Categories(state, {
                exclusiveFilter: [...existing, { id: nodeId }],
            });
        }
        case `${catalogs_1.CATALOG_PREFIX}${entityPrefix}${actions.REMOVE_FROM_EXCLUSIVE_FILTER}`: {
            const { payload } = action;
            const { nodeId } = payload !== null && payload !== void 0 ? payload : {};
            if (!nodeId)
                return state;
            const existing = (_b = state.exclusiveFilter) !== null && _b !== void 0 ? _b : [];
            const next = existing.filter((category) => category.id !== nodeId);
            return updateSelectedL1Categories(state, { exclusiveFilter: next });
        }
        case `${catalogs_1.CATALOG_PREFIX}${entityPrefix}${actions.CLEAR_EXCLUSIVE_FILTER}`:
            return updateSelectedL1Categories(state, { exclusiveFilter: [] });
        default:
            return state;
    }
};
exports.createSelectedL1CategoriesReducer = createSelectedL1CategoriesReducer;
